var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLikeIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4154_4996)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.6031,
    cy: 35.5316,
    rx: 24.6031,
    ry: 24.7606,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6776 27.7104C45.4971 26.4069 43.8772 25.689 42.1161 25.689C40.7997 25.689 39.5941 26.1127 38.5328 26.9482C37.9973 27.37 37.512 27.886 37.0842 28.4882C36.6565 27.8861 36.1711 27.37 35.6354 26.9482C34.5742 26.1127 33.3686 25.689 32.0522 25.689C30.2911 25.689 28.6711 26.4069 27.4906 27.7104C26.3242 28.9987 25.6816 30.7587 25.6816 32.6664C25.6816 34.63 26.4004 36.4273 27.9435 38.323C29.3239 40.0187 31.3079 41.7401 33.6054 43.7334C34.39 44.4141 35.2792 45.1857 36.2026 46.0076C36.4465 46.2252 36.7595 46.3449 37.0842 46.3449C37.4087 46.3449 37.7218 46.2252 37.9654 46.008C38.8888 45.1859 39.7786 44.414 40.5634 43.7329C42.8606 41.7399 44.8446 40.0187 46.225 38.3229C47.7681 36.4273 48.4867 34.63 48.4867 32.6663C48.4867 30.7587 47.8442 28.9987 46.6776 27.7104Z",
    fill: "#005B7A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4154_4996",
    x: 0.597468,
    y: 0.508718,
    width: 72.0111,
    height: 72.3265,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3.42076,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_4154_4996"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14025
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.41165
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 0 0.6875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4154_4996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4154_4996",
    result: "shape"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIconBlue);
export default __webpack_public_path__ + "static/media/likeIconBlue.95a419346b8c97544d857223dfc2aaab.svg";
export { ForwardRef as ReactComponent };